import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import useFloating from 'hooks/layers/useFloating';
import React from 'react';
import FocusableButton from './FocusableButton';
import HBox from './HBox';
import VBox from './VBox';

const defaultRenderer = (item) => (
  <data
    {...{
      value: item.value,
      'data-label': item.label,
    }}>
    <div>
      {item.label}
    </div>
  </data>
);

const SELECT_ID = 'Select';
export default React.forwardRef(function SelectButton(props, outerRef) {
  const {
    tags,
    category,
    placeholder,
    onChange,
    options = [],
    value,
    defaultValue = '',
    optionRenderer = defaultRenderer,
    ...rest
  } = props || {};

  const ref = React.useRef(null);
  React.useImperativeHandle(outerRef, () => ref.current, []);

  const [list, setList] = Recoil.useRecoilState(AppStore.floatings.list('App'));
  const [hash, setHash] = Recoil.useRecoilState(AppStore.floatings.hash('App'));
  const {
    open,
    update,
    close,
  } = useFloating({ setList, setHash });

  const [active, setActive] = React.useState(false);
  const disactive = React.useCallback(() => {
    setActive(() => false);
  }, []);
  const onOuterClick = React.useCallback((ref) => (e) => {
    if (!ref?.current?.contains(e.target)) {
      close(SELECT_ID, disactive);
    }
  }, [close, disactive]);
  const onClose = React.useCallback((e) => {
    close(SELECT_ID, disactive);
  }, [close, disactive]);


  const [label, setLabel] = React.useState(() => (options.find(item => item.value === value) || {}).label || null);
  React.useEffect(() => {
    setLabel(() => (options.find(item => item.value === value) || {}).label || null);
  }, [options, value]);
  // const [value, setValue] = React.useState(() => defaultValue || null);

  const onSubmit = React.useCallback((e) => {
    const data = e.target.querySelector("data");
    setLabel(() => data.getAttribute('data-label'));
    // setValue(() => data.value);
    e.target = data;
    onChange(e);
    close(SELECT_ID, disactive);
  }, [close, disactive, onChange]);
  const onClick = React.useCallback(() => {
    if (!options.length) return;
    setActive(() => true);
    open({
      id: SELECT_ID,
      reference: ref,
      placement: 'bottom-left',
      connection: 'none',
      width: 'auto',
      height: 'auto',
      veilable: true,
      stickable: true,
      movable: false,
      closable: false,
      escapable: false,
      modal: true,
      type: SELECT_ID,
      tags,
      events: {
        onOuterClick,
        onClose,
        onSubmit,
      },
      props: {
        defaultValue: value || defaultValue,
        renderer: optionRenderer,
        item_list: options.map((option, index) => ({ ...option, index })),
      },
    });
  }, [open, tags, onOuterClick, onClose, onSubmit, value, defaultValue, optionRenderer, options]);

  return (
    <FocusableButton
      {...ex(['SelectButton', { active }], props)}
      {...{ ref, onClick }}
    >
      {value === null && (
        <div {...ex('Placeholder')}>
          {placeholder}
        </div>
      )}
      {value !== null && (
        <div>
          {label}
        </div>
      )}
      <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_76_87" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x={0} y={0} width={32} height={32}>
          <rect y={32} width={32} height={32} transform="rotate(-90 0 32)" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_76_87)">
          <path d="M22.4743 13.3333L15.7372 20L9 13.3333L10.1958 12.15L15.7372 17.6333L21.2785 12.15L22.4743 13.3333Z" fill="#9B9B9B" />
        </g>
      </svg>
    </FocusableButton>
  );
});
